export default "__VITE_ASSET__f1198ddb__"